import React from 'react'
import "./styles.scss";

const IphoneBottomLine: React.FC = () => {
  return <div className="iphone-bottom-line"></div> ;
}

export default IphoneBottomLine;
